import styles from "./ContactUsPage.module.css";
import PrimarySection from "../components/UI/PrimarySection";
import Heading from "../components/UI/Heading";
import contactBackgroundImg from "../assets/images/contact-bg.png";
import Updates from "../components/Home/Updates";
import CtaLink from "../components/CtaLink/CtaLink";
import Location from "../components/Contact/Location";

const ContactUsPage = () => {
  return (
    <>
      <PrimarySection
        className={styles.section}
        backgroundImage={contactBackgroundImg}
      >
        <Heading className={styles.heading} text1="Contact" text2="Us" />
      </PrimarySection>
      <CtaLink />
      <Location />
      <Updates />
    </>
  );
};

export default ContactUsPage;
